import { render } from "./KoteishisanSettingItem.vue?vue&type=template&id=08fa62d5&ts=true"
import script from "./KoteishisanSettingItem.vue?vue&type=script&lang=ts"
export * from "./KoteishisanSettingItem.vue?vue&type=script&lang=ts"

import "./KoteishisanSettingItem.vue?vue&type=style&index=0&id=08fa62d5&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__